import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class MediaCard extends Vue {
    @Prop()
    public entity: string;

    @Prop()
    public target: string;

    @Prop()
    public fileName: string;

    isImage = false;

    async mounted(): Promise<void> {
        try{
            this.isImage = false;
            switch (this.entity)
            {
                case 'jpg':
                case 'gif':
                case 'bmp':
                case 'png':
                    this.isImage = true;
            }
        }
        catch (error) {
            this.$emit("error", error);
        }
    }
}

